
    import {
        computed,
        defineComponent,
        unref,
    } from 'vue';
    import { useState } from 'vuex-composition-helpers';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import CheckBoxInputList from '@fr/vue/components/inputs/CheckBoxInputList.vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import { MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
    import useOperatorsFilterHotel from '../common/useOperatorsFilterHotel';

    const filtersMappingStoreName = 'mapForFilters';
    export default defineComponent({
        name: 'operators-filter-hotel',
        components: {
            Dropdown,
            CheckBoxInputList,
            CheckBoxInput,
        },
        setup(props, { emit }) {
            const {
                operators,
            } = useState<MapForFiltersState>(filtersMappingStoreName, ['operators']);

            const selectedOperators = computed({
                get: () => unref(operators),
                set: (value) => {
                    emit('operators-filter-changed', value);
                },
            });

            return {
                ...useOperatorsFilterHotel({ selectedOperators }),
                selectedOperators,
            };
        },
    });
